<template>
  <div id="main-wrapper" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
    <NavbarDark />

    <div class="page-title">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <h2 class="ipt-title">{{$t('Login')}}</h2>
            <!-- <span class="ipn-subtitle">Register On Resido Today</span> -->
          </div>
        </div>
      </div>
    </div>

    <section class="gray-simple">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-7 col-lg-8 col-md-9">
            <div class="card border-0 rounded-4 p-xl-4 p-lg-4 p-md-4 p-3">
              <div class="simple-form">

                <div class="form-header text-center mb-5">
                  <div class="effco-logo mb-2">
                    <router-link class="d-flex align-items-center justify-content-center" to="/">
                    </router-link>
                  </div>
                  <h4 class="fs-2">{{$t('Login')}}</h4>
                </div>

                <form @submit="submitLogin">
                  <div class="row">
                    <div class="col-lg-6 col-md-6">
                      <div class="form-group mb-3">
                        <label class="mb-1">{{ $t('Email Or Phone') }}-{{$t('If Phone Please Add Country Code (+963965***)')}}</label>
                        <input type="text" class="form-control" v-model="phone_or_email" :placeholder="$t('Email Or Phone')">
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6 mb-3">
                      <div class="form-group">
                        <label class="mb-1">{{$t('Password')}}</label><br><br>
                        <input type="password" class="form-control" v-model="password" placeholder="*******" />
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <button type="submit" class="btn btn-primary full-width fw-medium">
                      {{ $t('Login') }}
                      <i
                        class="fa-solid px-2"
                        :class="$i18n.locale === 'ar' ? 'fa-arrow-left-long' : 'fa-arrow-right-long'"
                      ></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <FooterTop :bg="'theme-bg'" />

    <FooterDark />

    <ScrollToTop />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import FooterDark from '@/components/footer/footer-dark.vue'
import FooterTop from '@/components/footer/footer-top.vue'
import NavbarDark from '@/components/navbar/navbar-dark.vue'
import ScrollToTop from '@/components/scroll-to-top.vue'
import { useToast } from "vue-toastification"
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n'

const router = useRouter();
const phone_or_email = ref('')
const password = ref('')
const toast = useToast()
const { t } = useI18n()
const submitLogin = async (e) => {
  e.preventDefault()

  const formData = new FormData()
  formData.append('phone_or_email', phone_or_email.value)
  formData.append('password', password.value)

  try {
    const response = await axios.post('/login', formData)

    const userId = response.data.user_id
    const token = response.data.token
    const userRole = response.data.user_role;
    localStorage.setItem('auth_token', token) 
    localStorage.setItem('user_type', userRole);  
    localStorage.setItem('user_id', userId);  
    console.log('Login successful:', response.data)
    if (userRole === 'Service Provider') {
      router.push(`/dashboard/${userId}`);
    } else {
      router.push(`/user_dashboard/${userId}`);
    }
  }  catch (error) {
    const status = error.response?.status
    let errorMessage

    if (status === 422) {
      errorMessage = t('Your account is not activated') 
    } else if (status === 404) {
      errorMessage = t('Your account has been deleted')
    } else {
      errorMessage = error.response?.data?.msg || t('Login failed. Please try again.')
    }

    console.error('Login error:', errorMessage)
    toast.error(errorMessage)
  }
}
</script>